// src/components/ModalBackdrop.jsx
import React from "react";

export default function ModalBackdrop({
  children,
  onClose,
  className = "",
  zIndex = "z-[1000]",
}) {
  function handleMouseDown(event) {
    if (event.target === event.currentTarget) {
      onClose?.();
    }
  }

  return (
    <div
      className={[
        "fixed inset-0 flex items-center justify-center",
        "bg-black/40 backdrop-blur-sm p-4",
        zIndex,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      onMouseDown={handleMouseDown}
      role="presentation"
    >
      {children}
    </div>
  );
}
